import { render, staticRenderFns } from "./Attract.vue?vue&type=template&id=7b4af4f6&scoped=true&"
import script from "./Attract.vue?vue&type=script&lang=js&"
export * from "./Attract.vue?vue&type=script&lang=js&"
import style0 from "./Attract.vue?vue&type=style&index=0&id=7b4af4f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4af4f6",
  null
  
)

export default component.exports